<mat-sidenav-container class="sidenav-container">
  <!-- Side Navigation -->
  <mat-sidenav #drawer class="sidenav" mode="over">
    <!-- Sidebar Header -->
    <div class="sidenav-header">
      <img src="/assets/LOGO_Containuel.png" alt="Logo" class="sidenav-logo">
      <span class="sidenav-title">Containuel</span>
    </div>

    <mat-nav-list>
      <!-- Navigation Section -->
      <div class="nav-section-label">Navigation</div>

      <div class="nav-item" *ngIf="!isFieldVorarbeiter">
        <a mat-list-item routerLink="/home" routerLinkActive="active" (click)="closeSidenav()">
          <div class="nav-link-content">
            <mat-icon class="nav-icon">home</mat-icon>
            <span class="nav-label">Startseite</span>
          </div>
        </a>
      </div>

      <div class="nav-item">
        <a mat-list-item routerLink="/elemente-liste" routerLinkActive="active" (click)="closeSidenav()">
          <div class="nav-link-content">
            <mat-icon class="nav-icon">inventory_2</mat-icon>
            <span class="nav-label">Lager</span>
          </div>
        </a>
      </div>

      <div class="nav-item" *ngIf="canSeePlanning">
        <a mat-list-item routerLink="/ressourcenplanung" routerLinkActive="active" (click)="closeSidenav()">
          <div class="nav-link-content">
            <mat-icon class="nav-icon">event_available</mat-icon>
            <span class="nav-label">Ressourcenplanung</span>
          </div>
        </a>
      </div>

      <div class="nav-item" *ngIf="canSeeStammkunden">
        <a mat-list-item routerLink="/stammkunden" routerLinkActive="active" (click)="closeSidenav()">
          <div class="nav-link-content">
            <mat-icon class="nav-icon">badge</mat-icon>
            <span class="nav-label">Stammkunden</span>
          </div>
        </a>
      </div>

      <div class="nav-item" *ngIf="canSeeMeineEinsaetze">
        <a mat-list-item routerLink="/stammkunden/meine-einsaetze" routerLinkActive="active" (click)="closeSidenav()">
          <div class="nav-link-content">
            <mat-icon class="nav-icon">engineering</mat-icon>
            <span class="nav-label">Meine Einsätze</span>
          </div>
        </a>
      </div>

      <!-- Wartung Menü -->
      <div class="nav-item" *ngIf="!isFieldVorarbeiter">
        <mat-list-item (click)="toggleWartungMenu()">
          <div class="menu-item">
            <div class="menu-content">
              <mat-icon class="nav-icon">build_circle</mat-icon>
              <span class="nav-label">Wartung</span>
            </div>
            <mat-icon class="expand-icon">{{isWartungExpanded ? 'expand_less' : 'expand_more'}}</mat-icon>
          </div>
        </mat-list-item>
      </div>

      <!-- Untermenü Wartung -->
      <div class="submenu" *ngIf="isWartungExpanded && !isFieldVorarbeiter">
        <div class="nav-item">
          <a mat-list-item routerLink="/wartung" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeSidenav()">
            <div class="submenu-item">
              <mat-icon class="submenu-icon">dashboard</mat-icon>
              <span class="nav-label">Dashboard</span>
            </div>
          </a>
        </div>
        <div class="nav-item">
          <a mat-list-item routerLink="/wartung/kunden" routerLinkActive="active" (click)="closeSidenav()">
            <div class="submenu-item">
              <mat-icon class="submenu-icon">group</mat-icon>
              <span class="nav-label">Kunden</span>
            </div>
          </a>
        </div>
      </div>

      <!-- SBOM Management Menü (nur für Admins) -->
      <div class="nav-item" *ngIf="isAdmin">
        <mat-list-item (click)="toggleSbomMenu()">
          <div class="menu-item">
            <div class="menu-content">
              <mat-icon class="nav-icon">inventory</mat-icon>
              <span class="nav-label">SBOM</span>
            </div>
            <mat-icon class="expand-icon">{{isSbomExpanded ? 'expand_less' : 'expand_more'}}</mat-icon>
          </div>
        </mat-list-item>
      </div>

      <!-- Untermenü SBOM -->
      <div class="submenu" *ngIf="isSbomExpanded && isAdmin">
        <div class="nav-item">
          <a mat-list-item routerLink="/sbom" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeSidenav()">
            <div class="submenu-item">
              <mat-icon class="submenu-icon">developer_board</mat-icon>
              <span class="nav-label">Projekte</span>
            </div>
          </a>
        </div>
        <div class="nav-item">
          <a mat-list-item routerLink="/wartung/kunden" routerLinkActive="active" (click)="closeSidenav()">
            <div class="submenu-item">
              <mat-icon class="submenu-icon">group</mat-icon>
              <span class="nav-label">Kunden</span>
            </div>
          </a>
        </div>
      </div>

      <div class="nav-item" *ngIf="isAdmin">
        <a mat-list-item routerLink="/berichte" routerLinkActive="active" (click)="closeSidenav()">
          <div class="nav-link-content">
            <mat-icon class="nav-icon">assessment</mat-icon>
            <span class="nav-label">Berichte</span>
          </div>
        </a>
      </div>

      <div class="nav-item" *ngIf="isAdmin">
        <a mat-list-item routerLink="/users/admindashboard" routerLinkActive="active" (click)="closeSidenav()">
          <div class="nav-link-content">
            <mat-icon class="nav-icon">admin_panel_settings</mat-icon>
            <span class="nav-label">Admin Dashboard</span>
          </div>
        </a>
      </div>

      <mat-divider class="nav-divider"></mat-divider>

      <!-- Logout -->
      <div class="nav-item logout-item" *ngIf="authService.isAuthenticated()">
        <mat-list-item (click)="logout()">
          <div class="nav-link-content">
            <mat-icon class="nav-icon">logout</mat-icon>
            <span class="nav-label">Abmelden</span>
          </div>
        </mat-list-item>
      </div>
    </mat-nav-list>
  </mat-sidenav>

  <!-- Main Content Area -->
  <mat-sidenav-content>
    <!-- Toolbar -->
    <mat-toolbar>
      <div class="toolbar-content">
        <div class="toolbar-left">
          <button mat-icon-button class="menu-toggle" (click)="toggleSidenav()" aria-label="Menü öffnen">
            <mat-icon>menu</mat-icon>
          </button>
        </div>

        <div class="logo-center">
          <a class="navbar-brand" [routerLink]="['/home']">
            <img src="/assets/LOGO_Containuel.png" alt="Containuel Logo">
          </a>
        </div>

        <!-- User Information -->
        <div class="user-info" *ngIf="authService.isAuthenticated()">
          <span class="user-greeting">{{ username }}</span>
          <button mat-icon-button class="user-avatar-btn" routerLink="/users" matTooltip="Mein Dashboard">
            <mat-icon>person</mat-icon>
          </button>
        </div>
        <button mat-icon-button *ngIf="!authService.isAuthenticated()" (click)="login()" matTooltip="Anmelden">
          <mat-icon>account_circle</mat-icon>
        </button>
      </div>
    </mat-toolbar>

    <!-- Page Content -->
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
